import React from 'react'
import { Tab } from 'semantic-ui-react'

export const TabPane = (name, content) => (
    { menuItem: name, render: () => <Tab.Pane key={name?.toLowerCase()} className='tabbed-content-container transparent no-border'>{content}</Tab.Pane> }
)

export const TabbedContainer = ({className, menuClassName, panes, defaultActiveIndex = 0}) => (
    <Tab
    className={className}
    defaultActiveIndex={defaultActiveIndex}
    menu={{className: menuClassName, attached: false, fluid: true, widths: panes?.length, size: 'small'}}
    panes={panes} />
)